/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BbsCategoryInfoRespVo } from './BbsCategoryInfoRespVo';
import {
    BbsCategoryInfoRespVoFromJSON,
    BbsCategoryInfoRespVoFromJSONTyped,
    BbsCategoryInfoRespVoToJSON,
    BbsCategoryInfoRespVoToJSONTyped,
} from './BbsCategoryInfoRespVo';

/**
 * 
 * @export
 * @interface ResponseListBbsCategoryInfoRespVo
 */
export interface ResponseListBbsCategoryInfoRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListBbsCategoryInfoRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListBbsCategoryInfoRespVo
     */
    message?: string;
    /**
     * 
     * @type {Array<BbsCategoryInfoRespVo>}
     * @memberof ResponseListBbsCategoryInfoRespVo
     */
    data?: Array<BbsCategoryInfoRespVo>;
}

/**
 * Check if a given object implements the ResponseListBbsCategoryInfoRespVo interface.
 */
export function instanceOfResponseListBbsCategoryInfoRespVo(value: object): value is ResponseListBbsCategoryInfoRespVo {
    return true;
}

export function ResponseListBbsCategoryInfoRespVoFromJSON(json: any): ResponseListBbsCategoryInfoRespVo {
    return ResponseListBbsCategoryInfoRespVoFromJSONTyped(json, false);
}

export function ResponseListBbsCategoryInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListBbsCategoryInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(BbsCategoryInfoRespVoFromJSON)),
    };
}

export function ResponseListBbsCategoryInfoRespVoToJSON(json: any): ResponseListBbsCategoryInfoRespVo {
    return ResponseListBbsCategoryInfoRespVoToJSONTyped(json, false);
}

export function ResponseListBbsCategoryInfoRespVoToJSONTyped(value?: ResponseListBbsCategoryInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(BbsCategoryInfoRespVoToJSON)),
    };
}

